import * as React from 'react';
import { NewbuildingCarousel, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { equals } from 'ramda';
import { TStandardMedia } from '../../settings';
import { Slide } from './parts/Slide';
import { firstPaintOptions, mediaSettings } from './config';
import * as styles from './Carousel.css';
import { NoImage } from '../NoImage';
import { EMediaType } from '../../types/gallery';
import { VideoSlide } from './parts/VideoSlide/VideoSlide';

interface ICarouselProps {
  slides: TStandardMedia[];
}

interface ICarouselState {
  slides: React.ReactNode[];
  currentSlide: number;
}

export class Carousel extends React.Component<ICarouselProps, ICarouselState> {
  public constructor(props: ICarouselProps) {
    super(props);

    this.state = {
      slides: this.prepareSlides(this.props.slides),
      currentSlide: 1,
    };
  }

  public componentDidMount() {
    this.setState({ slides: this.prepareSlides(this.props.slides) });
  }

  public componentDidUpdate(prevProps: Readonly<ICarouselProps>) {
    const { slides } = this.props;

    if (!equals(slides, prevProps.slides)) {
      this.setState({ slides: this.prepareSlides(this.props.slides), currentSlide: 1 });
    }
  }

  private prepareSlides = (banners: TStandardMedia[]) => {
    return banners.map((media, index) =>
      media.mediaType === EMediaType.Image ? (
        <Slide key={index} image={media} />
      ) : (
        <VideoSlide key={index} video={media} />
      ),
    );
  };

  private handleSlideChange = ({ currentSlide }: TOnSlideChangeParams) => {
    this.setState({ currentSlide });
  };

  public render() {
    const { slides, currentSlide } = this.state;

    if (!slides.length) {
      return (
        <div className={styles['carousel']}>
          <NoImage />
        </div>
      );
    }

    return (
      <section className={styles['carousel']}>
        <NewbuildingCarousel
          media={mediaSettings}
          firstPaintOptions={firstPaintOptions}
          slides={slides}
          defaultCurrentSlide={currentSlide}
          onSlideChange={this.handleSlideChange}
        />
      </section>
    );
  }
}
